import React from 'react';
import ReactDOM from 'react-dom';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UserProvider from "./contexts/UserContext";
import TabsProvider from "./contexts/TabsContext";
import EntitiesProvider from "./contexts/EntitiesContext";

const queryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <TabsProvider>
          <EntitiesProvider>
            <App />
          </EntitiesProvider>
        </TabsProvider>
      </UserProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
